import React from 'react';
import { stocks, stocks2, stocks3, stocks4 } from '../data/mock';

const StockCard = ({ stock }) => {
  const logoUrl = `https://assets-sir.kraken.com/equities/logos/v1/${stock.symbol}.png?i=kds`;
  
  return (
    <a 
      href="#" 
      className="flex items-center gap-4 px-5 py-4 bg-white/[0.03] hover:bg-white/[0.06] border border-white/[0.06] rounded-xl transition-all duration-200 min-w-[240px] group"
    >
      <div className="w-10 h-10 rounded-full overflow-hidden bg-white/10 flex-shrink-0">
        <img 
          src={logoUrl} 
          alt={stock.name}
          className="w-full h-full object-cover"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'flex';
          }}
        />
        <div className="w-full h-full hidden items-center justify-center text-white font-bold text-sm">
          {stock.symbol.charAt(0)}
        </div>
      </div>
      <div className="flex flex-col min-w-0">
        <span className="text-white font-medium truncate group-hover:text-purple-300 transition-colors">
          {stock.name}
        </span>
        <span className="text-gray-500 text-sm">{stock.ticker}</span>
      </div>
    </a>
  );
};

const MarqueeRow = ({ items, direction = 'left', speed = 30 }) => {
  const duplicatedItems = [...items, ...items, ...items];
  
  return (
    <div className="relative overflow-hidden py-2">
      <div 
        className={`flex gap-4 ${direction === 'left' ? 'animate-marquee-left' : 'animate-marquee-right'}`}
        style={{ 
          animationDuration: `${speed}s`,
        }}
      >
        {duplicatedItems.map((stock, index) => (
          <StockCard key={`${stock.symbol}-${index}`} stock={stock} />
        ))}
      </div>
    </div>
  );
};

const StockMarquee = () => {
  return (
    <section className="py-16 bg-[#0b0014] overflow-hidden">
      <div className="mb-8">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-4">
          Build your portfolio
        </h2>
      </div>
      
      <div className="space-y-4">
        <MarqueeRow items={stocks} direction="left" speed={40} />
        <MarqueeRow items={stocks2} direction="right" speed={45} />
        <MarqueeRow items={stocks3} direction="left" speed={42} />
        <MarqueeRow items={stocks4} direction="right" speed={38} />
      </div>
      
      <div className="text-center mt-12">
        <a 
          href="#" 
          className="inline-flex px-8 py-4 text-lg font-semibold text-white bg-[#7B61FF] hover:bg-[#6B4FFF] rounded-lg transition-all duration-200 hover:shadow-lg hover:shadow-purple-500/25"
        >
          Start Trading
        </a>
      </div>
    </section>
  );
};

export default StockMarquee;
